import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useGetAccessMember from './useGetAccessMember';

export const useProtectRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { permittedSections, loading } = useGetAccessMember();

  useEffect(() => {
    if (loading) return;

    const currentRoute = Object.entries(routes).find(
      (route) =>
        route[1].path.replaceAll('/', '') ===
        location.pathname.replaceAll('/', '')
    );

    if (
      currentRoute &&
      currentRoute[1].section !== 'not_allowed' &&
      currentRoute[1].section !== 'not_found' &&
      currentRoute[1].section !== 'server_error' &&
      currentRoute[1].section !== 'account' &&
      currentRoute[1].section !== 'choose_cabinet' &&
      currentRoute[1].section !== 'tariffs_and_payments' &&
      currentRoute[1].section !== 'faq' &&
      currentRoute[1].section !== 'faq_article' &&
      currentRoute[1].section !== 'faq_categories' &&
      currentRoute[1].section !== 'mutual_settlements' &&
      !permittedSections?.includes(currentRoute[1].section)
    ) {
      navigate(routes.notAllowed.path);
    }
  }, [permittedSections, loading, location]);
};
